import { touch } from "@/state/store";

const isTouch = typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;

type Key = keyof typeof touch;

function Btn({ k, label, cls }: { k: Key; label: string; cls: string }) {
  const on = () => (touch[k] = true);
  const off = () => (touch[k] = false);
  return (
    <button
      class={`touch-btn ${cls}`}
      onPointerDown={(e) => {
        e.preventDefault();
        on();
      }}
      onPointerUp={off}
      onPointerLeave={off}
      onPointerCancel={off}
      onContextMenu={(e) => e.preventDefault()}
    >
      {label}
    </button>
  );
}

export function TouchControls() {
  if (!isTouch) return null;
  return (
    <>
      <div class="dpad">
        <Btn k="up" label="▲" cls="up" />
        <Btn k="left" label="◀" cls="left" />
        <Btn k="right" label="▶" cls="right" />
        <Btn k="down" label="▼" cls="down" />
      </div>
      <Btn k="action" label="A" cls="action" />
    </>
  );
}
